<div class="panneau-lecture-terminal__container">
	<div class="container__content">
	    <di-lecture-terminal></di-lecture-terminal>
    </div>
</div>
